import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'every', standalone: true })
export class EveryPipe<T> implements PipeTransform {
  transform(value: Array<T>, callback: (item: T) => boolean): boolean {
    return value.every(callback);
  }
}
